import { GLOBAL_TRANSLATIONS_RELATIVE_PATH } from 'redpoints-front-common/helpers';

import {
  getTranslate,
  getTranslateWithGlobal,
} from 'redpoints-front-translate';
import GlobalTranslate from 'redpoints-front-translate/GlobalTranslate';

import en from '../locales/en.json';

let translate = getTranslate(en);

const globalTranslationItems = ['protectiontype.'];

const loadGlobalTranslate = async () => {
  try {
    if (GlobalTranslate.isLoaded()) {
      translate = getTranslateWithGlobal(en);
    } else {
      GlobalTranslate.subscribe(() => (translate = getTranslateWithGlobal(en)));

      if (!GlobalTranslate.isLoading()) {
        await GlobalTranslate.load(GLOBAL_TRANSLATIONS_RELATIVE_PATH);
      }
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Global translations not loaded', error);
  }
};

// Don't await this function until this: https://github.com/tc39/proposal-top-level-await
loadGlobalTranslate();

const translateEnumList = enumList =>
  enumList.map(item => ({
    ...item,
    translated: translate(item.literalKey),
  }));

const getLiteralKey = literalKey => {
  const isGlobalLiteralKey = globalTranslationItems.some(item =>
    literalKey.startsWith(item)
  );
  return isGlobalLiteralKey ? `global.${literalKey}` : literalKey;
};

export {
  GLOBAL_TRANSLATIONS_RELATIVE_PATH,
  getLiteralKey,
  translate,
  translateEnumList,
};
